import { Component, EventEmitter, Inject, OnInit, Optional, Output } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { GridModalComponent } from '../../../core/components/grid/grid.decorators';
import { StateDialogContext, TT_STATE_DIALOG } from '../../../modal/state-modal/state-modal.component';

@GridModalComponent('discgrpprod')
@Component({
  selector: 'tt-disc-grp-prod',
  templateUrl: './disc-grp-prod.component.html',
  styleUrls: ['./disc-grp-prod.component.css']
})
export class DiscGrpProdComponent implements OnInit {
    @Output()
    public submit = new EventEmitter<string>();

    discGrpProdKeyno;

    public edit?: Edit;

    public selectListPriceMethods: PriceMethodItem[] = [];

    public discountGroupProductNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'discgrpprodlangs', gotoParms: () => this.edit!.discgrpprod_keyno ?? '' }
    ];

    public saving = false;
    
    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, @Inject(TT_STATE_DIALOG) @Optional() stateDialog: StateDialogContext,) {
        this.discGrpProdKeyno = this.stateService.getStateParams()['discgrpprod_keyno'];
        this.initFromDialog(stateDialog);
    }

    private async loadEdit() {
        if (!!this.discGrpProdKeyno) {
            this.edit = (await this.datatask.Post(3113, { discgrpprod_keyno: this.discGrpProdKeyno }))[0];
        }
    }

    private async loadPriceMethods(): Promise<void> {
        this.selectListPriceMethods = await this.datatask.Post(823);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3114, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    if (this.stateService.getCurrentName() === 'discgrpprod') {
                        this.stateService.back();
                    } else {
                        this.submit.emit(response.errorcode);
                    }
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadPriceMethods();
    }

    ngOnInit() {
        if (this.stateService.getCurrentName() === 'discgrpprod') {
            this.init();
        }
    }

    private async initFromDialog(stateDialog?: StateDialogContext) {
        if (!!stateDialog?.params && 'discgrpprod_keyno' in stateDialog.params) {
            this.edit = stateDialog.params as unknown as Edit;
            stateDialog.setSize({ height: '80vh', width: '80vw' });
            await this.init();
            stateDialog.setHeading('p2_m_discgrpprod', true);
            this.submit.subscribe({ next: (value: string) => stateDialog.close(value) });
        }
    }
}

interface Edit {
    discgrpprod_keyno: string;
    discgrpprod_name: string;
    pricemethod_id: number;
    calc_factor: string;
    calc_margin_pst: string;
}

interface PriceMethodItem {
    pricemethod_id: number;
    pricemethod_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpProd', {
//        templateUrl: 'views/components/views/discGrpProd/discGrpProd.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'discGrpProdService', 'economyService', function ($stateParams, stateService, modalService, translateService, discGrpProdService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let discGrpProdKeyno = $stateParams.discgrpprod_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                discGroupProductNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('discgrpprodlangs', { discgrpprod_keyno: vm.model.edit.discgrpprod_keyno }) }
//                ],
//                edit: {},
//                selectListPriceMethods: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await discGrpProdService.getEdit({ discgrpprod_keyno: discGrpProdKeyno }))[0];
//            }

//            async function loadPriceMethods() {
//                vm.model.selectListPriceMethods = await economyService.listPriceMethods();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                discGrpProdService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadPriceMethods();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
